export enum AlertsFiltersTypes {
    AlertForDate = 'alert_for_date',
}